import React from "react";
import CharacterSheetsStack from "../CharacterSheets/CharacterSheetsStack";
import { getSurvivorQuickStats } from "./settlementRules";
export default function SurvivorsPanel({ newName, setNewName, handleAdd, openAllSheets, closeAllSheets, limit, departingIds, aliveSurvivors, deceasedSurvivors, openSheetIds, toggleDepartingWithGuard, updateSurvivor, campaignKeyBase, useArc, toggleInlineSheet, removeSurvivor }) { return <>
      {/* Survivors */}
      <hr style={{ margin: "14px 0" }} />
      <h3>Survivors</h3>

      <div style={{ display: "flex", gap: 10, marginTop: 8, alignItems: "center" }}>
        <input
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder="New survivor name"
          style={{ padding: 8, width: 260 }}
        />
        <button onClick={handleAdd}>Add Survivor</button>

        <button onClick={openAllSheets} style={{ marginLeft: 8 }}>
          Open All Sheets
        </button>

        <button onClick={closeAllSheets} style={{ marginLeft: 8 }}>
          Close All Sheets
        </button>

        <div style={{ marginLeft: "auto", opacity: 0.85 }}>
          Departing limit: <b>{limit}</b> (selected {departingIds.length})
        </div>
      </div>

      <div style={{ marginTop: 12 }}>
        {aliveSurvivors.length === 0 && deceasedSurvivors.length === 0 ? (
          <div style={{ opacity: 0.8 }}>No survivors yet.</div>
        ) : (
          <table style={{ borderCollapse: "collapse", width: "100%", marginTop: 8 }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Departing</th>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Name</th>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Stats</th>
                <th style={{ borderBottom: "1px solid #ddd", padding: 8 }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {aliveSurvivors.map((s) => {
                const isDeparting = departingIds.includes(s.id);
                const isOpen = openSheetIds.has(s.id);

                return (
                  <React.Fragment key={s.id}>
                    <tr>
                      <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                        <input type="checkbox" checked={isDeparting} onChange={() => toggleDepartingWithGuard(s.id)} />
                      </td>

                      <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          {!isOpen && s.borderColor ? (
                            <span
                              title={`Color: ${s.borderColor}`}
                              style={{
                                width: 12,
                                height: 12,
                                borderRadius: 999,
                                background: s.borderColor,
                                border: "1px solid rgba(0,0,0,0.25)",
                                flex: "0 0 auto",
                              }}
                            />
                          ) : null}

                          <input
                            value={s.name}
                            onChange={(e) => updateSurvivor(s.id, { name: e.target.value })}
                            style={{ width: "100%", padding: 6 }}
                          />
                        </div>
                      </td>

                                            <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                        {(() => {
                          const qs = s.__qs || getSurvivorQuickStats(s, useArc);
                          const st = qs.baseStats;

                          return (
                            <div style={{ fontSize: 12, lineHeight: 1.25 }}>
                              <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                                <span>
                                  <b>Hunt XP:</b> {qs.huntXPCount}/16
                                </span>
                                <span>
                                  <b>Weap Prof:</b>{" "}
                                  {qs.weaponName && qs.weaponName.trim() !== ""
                                    ? `${qs.weaponName} ${qs.weaponProfCount}/8`
                                    : "0/8"}
                                </span>
                                <span>
                                  <b>Courage:</b> {qs.courageCount}/9
                                </span>
                                <span>
                                  <b>Understanding:</b> {qs.understandingCount}/9
                                </span>
                              </div>

                              <div style={{ marginTop: 4, display: "flex", flexWrap: "wrap", gap: 10 }}>
                                <span>
                                  <b>MOV</b> {st.mov}
                                </span>
                                <span>
                                  <b>ACC</b> {st.acc}
                                </span>
                                <span>
                                  <b>STR</b> {st.str}
                                </span>
                                <span>
                                  <b>EVA</b> {st.eva}
                                </span>
                                <span>
                                  <b>LUC</b> {st.luc}
                                </span>
                                <span>
                                  <b>SPD</b> {st.spd}
                                </span>
                              </div>
                            </div>
                          );
                        })()}
                      </td>

                      <td style={{ padding: 8, borderBottom: "1px solid #eee", textAlign: "center" }}>
                        <button onClick={() => toggleInlineSheet(s.id)}>{isOpen ? "Hide Sheet" : "View Sheet"}</button>
                        <button onClick={() => removeSurvivor(s.id)} style={{ marginLeft: 8 }}>
                          Remove
                        </button>
                      </td>
                    </tr>

                    {isOpen ? (
                      <tr>
                        <td colSpan={4} style={{ padding: 12, borderBottom: "1px solid #eee" }}>
                          <CharacterSheetsStack
                            initialType={useArc ? "arc" : "character"}
                            survivors={[s]}
                            campaignKeyBase={campaignKeyBase}
                            onSetColor={(id, color) => updateSurvivor(id, { borderColor: color })}
                            showColorPicker={true}
                            borderWidth={8}
                            getTitle={() => `Survivor Sheet: ${s.name}`}
                          />
                        </td>
                      </tr>
                    ) : null}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        )}
      </div>


      {/* Deceased Survivors (always at bottom, sorted by name) */}
      {deceasedSurvivors.length > 0 ? (
        <div style={{ marginTop: 18 }}>
          <h3 style={{ marginTop: 0 }}>Deceased Survivors</h3>

          <table style={{ borderCollapse: "collapse", width: "100%", marginTop: 8 }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Name</th>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Stats</th>
                <th style={{ borderBottom: "1px solid #ddd", padding: 8 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {deceasedSurvivors.map((s) => {
                const isOpen = openSheetIds.has(s.id);
                const qs = s.__qs || getSurvivorQuickStats(s, useArc);
                const st = qs.baseStats;

                return (
                  <React.Fragment key={s.id}>
                    <tr>
                      <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                        <input
                          value={s.name}
                          onChange={(e) => updateSurvivor(s.id, { name: e.target.value })}
                          style={{ width: "100%", padding: 6 }}
                        />
                      </td>

                      <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                        <div style={{ fontSize: 12, lineHeight: 1.25 }}>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                            <span>
                              <b>Hunt XP:</b> {qs.huntXPCount}/16
                            </span>
                            <span>
                              <b>Weap Prof:</b>{" "}
                              {qs.weaponName && qs.weaponName.trim() !== ""
                                ? `${qs.weaponName} ${qs.weaponProfCount}/8`
                                : "0/8"}
                            </span>
                            <span>
                              <b>Courage:</b> {qs.courageCount}/9
                            </span>
                            <span>
                              <b>Understanding:</b> {qs.understandingCount}/9
                            </span>
                          </div>

                          <div style={{ marginTop: 4, display: "flex", flexWrap: "wrap", gap: 10 }}>
                            <span><b>MOV</b> {st.mov}</span>
                            <span><b>ACC</b> {st.acc}</span>
                            <span><b>STR</b> {st.str}</span>
                            <span><b>EVA</b> {st.eva}</span>
                            <span><b>LUC</b> {st.luc}</span>
                            <span><b>SPD</b> {st.spd}</span>
                          </div>
                        </div>
                      </td>

                      <td style={{ padding: 8, borderBottom: "1px solid #eee", textAlign: "center" }}>
                        <button onClick={() => toggleInlineSheet(s.id)}>{isOpen ? "Hide Sheet" : "View Sheet"}</button>
                        <button onClick={() => removeSurvivor(s.id)} style={{ marginLeft: 8 }}>
                          Remove
                        </button>
                      </td>
                    </tr>

                    {isOpen ? (
                      <tr>
                        <td colSpan={3} style={{ padding: 12, borderBottom: "1px solid #eee" }}>
                          <CharacterSheetsStack
                            initialType={useArc ? "arc" : "character"}
                            survivors={[s]}
                            campaignKeyBase={campaignKeyBase}
                            onSetColor={(id, color) => updateSurvivor(id, { borderColor: color })}
                            showColorPicker={true}
                            borderWidth={8}
                            getTitle={() => `Survivor Sheet: ${s.name}`}
                          />
                        </td>
                      </tr>
                    ) : null}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : null}


</>; }
